import React from 'react';

import { Button, Flex, Text } from '@opendoor/bricks/core';

import { customerDataProps } from '../../helpers/getAllLeadData';

interface CustomerInfoProps {
  customerData?: customerDataProps;
}

export const CustomerInfo: React.FC<CustomerInfoProps> = ({ customerData }) => {
  const [showCustomerInfo, setShowCustomerInfo] = React.useState(false);
  return (
    <Flex
      flexDirection="column"
      fontSize="s2"
      alignItems="start"
      p={3}
      borderRadius="semiRounded"
      backgroundColor="neutrals20"
    >
      <Text my={3} fontWeight="semibold">
        Customer name: {customerData?.name}
      </Text>
      <Button
        analyticsName="open-customer-info"
        variant="secondary"
        onClick={() => {
          setShowCustomerInfo(!showCustomerInfo);
        }}
        aria-label="Open customer information"
      >
        <Text fontWeight="semibold">
          {`${showCustomerInfo ? 'Hide' : 'Show'} customer information`}{' '}
        </Text>
      </Button>
      {showCustomerInfo && (
        <>
          <Text>{customerData?.name}</Text>

          <a href={`tel:${customerData?.phone}`}>{customerData?.phone}</a>

          <Text>{customerData?.email}</Text>

          <Text>{customerData?.address}</Text>
        </>
      )}
    </Flex>
  );
};
